export function normalizePhoneNumber(value: string) {
  return value.replace(/[^0-9]/g, "");
}

export function formatPhoneNumber(value: string) {
  const digits = normalizePhoneNumber(value).slice(0, 11);

  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export function isValidMobilePhoneNumber(value: string) {
  const digits = normalizePhoneNumber(value);
  return /^01\d{8,9}$/.test(digits);
}
